export default __webpack_public_path__ + "static/small-text-do-c1d15ffa43abdd0dc9b44d0a5e3f383bdd951a686ab66559c5d2139f86e94fcd.png";